import type { ImportWizardStep } from '@discovr/features';
import type { ImportTarget } from '@discovr/types';
import { importPlatformSubtitle } from './importIdentityWording';

/** The line under the wizard's title. Always the dialog's accessible
 *  description; `visible` is false on steps that show no subtitle. */
export interface ImportWizardSubtitle {
  text: string;
  visible: boolean;
}

interface SubtitleCampaign {
  name: string;
  platform: string;
}

type SubtitleResolver = (campaign: SubtitleCampaign, target: ImportTarget) => ImportWizardSubtitle;

const SCREEN_READER_DESCRIPTION: Record<ImportTarget, string> = {
  pipeline: 'Upload, match and review a creator sheet',
  outreach: "Add creators to this campaign's outreach",
};
const REVIEW_SUBTITLE = 'Fix what we flagged, then continue.';

function screenReaderDescription(_campaign: SubtitleCampaign, target: ImportTarget): ImportWizardSubtitle {
  return { text: SCREEN_READER_DESCRIPTION[target], visible: false };
}

function reviewSubtitle(): ImportWizardSubtitle {
  return { text: REVIEW_SUBTITLE, visible: true };
}

function mappingSubtitle(campaign: SubtitleCampaign, target: ImportTarget): ImportWizardSubtitle {
  const text = importPlatformSubtitle(campaign.name, campaign.platform);
  if (text === null) return screenReaderDescription(campaign, target);
  return { text, visible: true };
}

const SUBTITLE_BY_STEP: Record<ImportWizardStep, SubtitleResolver> = {
  upload: screenReaderDescription,
  mapping: mappingSubtitle,
  review: reviewSubtitle,
  importing: reviewSubtitle,
  done: screenReaderDescription,
};

export function importWizardSubtitle(
  step: ImportWizardStep,
  campaign: SubtitleCampaign,
  target: ImportTarget = 'pipeline',
): ImportWizardSubtitle {
  return SUBTITLE_BY_STEP[step](campaign, target);
}
